<template>
  <div class="notice-page">
    <div class="notice-list">
      <div class="notice-list-box" v-for="(item, i) in resultList" :key="i">
        <div class="title">
          <div>{{ item.title }}</div>
          <div class="time">{{ item.createTime }}</div>
        </div>
        <!-- <div class="rmks" v-html="item.content"></div> -->
        <div class="detail" @click="goDetail(item.noticeId)">
          <span>查看详情</span>
          <span style="color: #b5b4ba;">></span>
        </div>
      </div>
    </div>
    <div class="back-btn" @click="$router.back()">返回</div>
  </div>
</template>

<script>
import { getNoticeList } from '@/api/common'

export default {
  name: 'noticePage',
  data() {
    return {
      resultList: [],
    }
  },
  methods: {
    getList() {
      getNoticeList({}).then((res) => {
        this.resultList = res.data
      })
    },
    goDetail(id) {
      this.$router.push({
        path: '/notice/detail',
        query: {
          id: id,
        },
      })
    },
  },
  created() {},
  mounted() {
    this.getList()
  },
}
</script>

<style lang="scss">
.notice-page {
  width: 100%;
  padding: 20px 0;
  overflow-y: scroll;
  height: 100%;
  background: url('../../assets/img/notice-bg.png') top center no-repeat;
  background-size: contain;
  .notice-list {
    margin: 0 20px;
    padding-bottom: 20px;
    &-box {
      font-size: 12px;
      padding: 10px 16px;
      background-color: #fff;
      margin-bottom: 14px;
      border-radius: 8px;
      & > div {
        margin-bottom: 6px;
      }
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #000;
        font-size: 15px;
        font-weight: 500;
        margin-bottom: 12px;
        padding-bottom: 10px;
        border-bottom: 0.5px solid #dad9de;
        .time {
          color: #b5b4ba;
          font-family: 'Porsche Next';
          font-size: 10px;
          font-weight: 400;
        }
      }
      .time {
        font-size: 10px;
        font-weight: 400;
        color: #b5b4ba;
      }
      .rmks {
        font-size: 14px;
        color: #737278;
        padding-bottom: 10px;
        border-bottom: 0.5px solid #dad9de;
        img {
          width: 100%;
        }
      }
      .detail {
        display: flex;
        justify-content: space-between;
        align-items: end;
        color: #403f45;
        font-size: 14px;
        margin-bottom: 0;
      }
    }
  }
}
</style>
